import { path, pathOr, dissoc } from 'ramda';
import {
	CLEAR_REMINDERS,
	GET_REMINDERS,
	FETCH_REMINDERS_FAILED,
	FETCH_REMINDERS_SUCCEEDED,
	DELETE_REMINDER,
	DELETE_REMINDER_FAILED,
	DELETE_REMINDER_SUCCEEDED,
} from './reminder.action';
import { remindersInitialState } from './reminder.initialState';

const createPendingState = (state, pendingType) => ({
	...state,
	[pendingType]: true,
});

const createErrorState = (state, pendingType, errorType, error) => ({
	...state,
	[pendingType]: false,
	[errorType]: error,
});

export const reminderReducer = (state = remindersInitialState, action) => {
	switch (action.type) {
		case CLEAR_REMINDERS: {
			return {
				...state,
				...remindersInitialState,
			};
		}

		case GET_REMINDERS: {
			return createPendingState(state, 'pendingFetch');
		}

		case FETCH_REMINDERS_FAILED: {
			return createErrorState(state, 'pendingFetch', 'fetchError', action.payload);
		}

		case FETCH_REMINDERS_SUCCEEDED: {
			const data = pathOr([], ['payload', 'data'], action);
			const entities = data.reduce((accumulator, datum) => {
				accumulator[datum._id] = datum;

				return accumulator;
			}, {});

			return {
				...state,
				entities,
				pendingFetch: false,
			};
		}

		case DELETE_REMINDER_FAILED: {
			return createErrorState(state, 'pendingDelete', 'deleteError', action.payload);
		}

		case DELETE_REMINDER_SUCCEEDED: {
			const deletedReminderId = path(['payload', '_id'], action);
			const newState = {
				...state,
				isDirty: true,
				pendingDelete: false,
			};

			if (deletedReminderId) {
				newState.entities = dissoc(deletedReminderId, state.entities);
			}

			return newState;
		}

		case DELETE_REMINDER: {
			return createPendingState(state, 'pendingDelete');
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/reminders/reminder.reducer.js